import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
  },
  buttonContainer: {
    maxWidth: 1000,
    margin: '0 auto 10px',
  },
  formStyle: {
    alignItems: 'flex-start !important',
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',

    '& .inputEach': {
      alignItems: 'flex-start',
    },
    '& .titleContainer': {
      marginBottom: 0,
    },
    '& .vendorsInnerContainer': {
      padding: 0,

      '& .vendorRealmContainer': {
        margin: 0,
      },
    },
  },
  chip: {
    backgroundColor: theme.palette.grey['100'],
    marginRight: 5,
  },
  chipIcon: {
    color: '#57b400',
  },
  screenWidth: {
    width: '100%',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl, .Mui-disabled': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
  },
  screenContainer: {
    maxWidth: 400,
    padding: `0 ${theme.spacing(3)}`,
  },
  screenContainerMobile: {
    maxWidth: 'none !important',
  },
  accessContainer: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    width: '100%',
    '& .MuiFilledInput-root.Mui-disabled.MuiInputBase-formControl': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl, .MuiFormControlLabel-label.Mui-disabled': {
      color: theme.palette.text.primary,
    },
  },
  dropZone: {
    border: `1px solid ${theme.colors.disabledGray} !important`,
    borderRadius: `4px  !important`,
    minHeight: 'auto !important',
    backgroundColor: `${theme.colors.transparent}  !important`,
    '&:hover': {
      border: `1px solid ${theme.palette.text.primary} !important`,
    },
    '& p': {
      fontSize: '14px !important',
      textAlign: 'left !important',
      padding: `${theme.spacing(1)} ${theme.spacing(2)} !important`,
    },
    '& > div > svg': {
      display: 'none !important',
    },
  },
  dropIcon: {
    position: 'absolute',
    right: 9,
    top: 17,
    color: theme.palette.primary.main,
  },
}));

export default useStyles;
